import React from "react";

const colors = {
  mainBlue: "#061941",
  gold: "#F2AF29",
  isabelline: "#F4F3EE",
  muted: "#6B7280",
};

export default function ProfessorCard({ professor, onContact }) {
  const photo = professor.photoURL || professor.photo || null;

  const showOrNA = (value) => {
    if (Array.isArray(value)) return value.length > 0 ? value : "N/A";
    if (value === null || value === undefined || value === "") return "N/A";
    return value;
  };

  return (
    <div
      style={{
        background: "white",
        borderRadius: 8,
        boxShadow: "0 4px 18px rgba(6,25,65,0.08)",
        padding: "16px",
        display: "flex",
        gap: "12px",
        alignItems: "flex-start",
        width: "100%",
      }}
    >
      <div
        style={{
          width: 80,
          height: 80,
          borderRadius: 8,
          background: colors.isabelline,
          overflow: "hidden",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        {photo ? (
          <img
            src={photo}
            alt={professor.name || "Professor"}
            style={{ width: "100%", height: "100%", objectFit: "cover" }}
          />
        ) : (
          <div style={{ color: colors.mainBlue, fontWeight: 700 }}>
            {(professor.name || "N/A")
              .split(" ")
              .map((n) => n[0] || "")
              .join("")
              .toUpperCase()}
          </div>
        )}
      </div>

      <div style={{ flex: 1 }}>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: 8,
          }}
        >
          <div>
            <div
              style={{
                fontSize: "1rem",
                fontWeight: 700,
                color: colors.mainBlue,
              }}
            >
              {showOrNA(professor.name)}
            </div>

            <div style={{ marginTop: 6 }}>
              <span
                style={{
                  fontWeight: 600,
                  color: colors.muted,
                  fontSize: "0.85rem",
                }}
              >
                Institution:{" "}
              </span>
              <span style={{ color: colors.gold, fontSize: "0.9rem" }}>
                {showOrNA(
                  professor.professorInstitution || professor.institution
                )}
              </span>
            </div>

            <div style={{ marginTop: 4 }}>
              <span
                style={{
                  fontWeight: 600,
                  color: colors.muted,
                  fontSize: "0.8rem",
                }}
              >
                Department:{" "}
              </span>
              <span style={{ color: colors.muted, fontSize: "0.8rem" }}>
                {showOrNA(professor.professorDepartment)}
              </span>
            </div>
          </div>

          <div style={{ textAlign: "right" }}>
            <div>
              <span
                style={{
                  fontWeight: 600,
                  color: colors.muted,
                  fontSize: "0.85rem",
                }}
              >
                Rank:{" "}
              </span>
              <span style={{ color: colors.muted, fontSize: "0.85rem" }}>
                {showOrNA(professor.professorRank)}
              </span>
            </div>
            <div style={{ marginTop: 6 }}>
              <span
                style={{
                  fontWeight: 600,
                  color: colors.muted,
                  fontSize: "0.75rem",
                }}
              >
                Referrals:{" "}
              </span>
              <span style={{ color: colors.muted, fontSize: "0.75rem" }}>
                {typeof professor.referralCount !== "undefined"
                  ? professor.referralCount
                  : "N/A"}
              </span>
            </div>
          </div>
        </div>

        <div style={{ marginTop: 10 }}>
          <span
            style={{
              fontWeight: 600,
              color: colors.muted,
              fontSize: "0.85rem",
            }}
          >
            Interests:{" "}
          </span>
          {Array.isArray(professor.interests) &&
          professor.interests.length > 0 ? (
            <div
              style={{
                marginTop: 6,
                display: "flex",
                gap: 8,
                flexWrap: "wrap",
              }}
            >
              {professor.interests.slice(0, 6).map((i, idx) => (
                <div
                  key={idx}
                  style={{
                    background: "#F8FAFC",
                    padding: "6px 8px",
                    borderRadius: 6,
                    fontSize: "0.75rem",
                    color: "#334155",
                  }}
                >
                  {i}
                </div>
              ))}
            </div>
          ) : (
            <div
              style={{ marginTop: 6, color: colors.muted, fontSize: "0.85rem" }}
            >
              N/A
            </div>
          )}
        </div>

        <div style={{ marginTop: 10 }}>
          <span
            style={{
              fontWeight: 600,
              color: colors.muted,
              fontSize: "0.85rem",
            }}
          >
            Webpage:{" "}
          </span>
          {professor.professorWebPage ? (
            <a
              href={professor.professorWebPage}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: colors.mainBlue,
                fontSize: "0.85rem",
                marginLeft: 6,
              }}
            >
              Visit webpage
            </a>
          ) : (
            <span
              style={{
                marginLeft: 6,
                color: colors.muted,
                fontSize: "0.85rem",
              }}
            >
              N/A
            </span>
          )}
        </div>

        {/* Contact Button */}
        {professor.email && (
          <div
            style={{
              marginTop: 14,
              paddingTop: 12,
              borderTop: "1px solid #E5E7EB",
            }}
          >
            <button
              type="button"
              onClick={(e) => {
                e.stopPropagation();
                if (onContact) {
                  onContact();
                }
              }}
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                padding: "10px 16px",
                backgroundColor: colors.mainBlue,
                color: "white",
                borderRadius: "6px",
                fontSize: "0.875rem",
                fontWeight: 600,
                transition: "all 0.2s ease",
                border: "none",
                cursor: "pointer",
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.backgroundColor = "#0a2659";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.backgroundColor = colors.mainBlue;
              }}
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                <polyline points="22,6 12,13 2,6" />
              </svg>
              Contact Professor
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
